import React from 'react'
import Home from './home'
const App = () => {
  return (
    <div>
        <Home />
    </div>
  )
}

export default App
